module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-24/arrow-43688c4a4ca4e046b9b971c4151c50a8.png";